export default __webpack_public_path__ + "static/media/mario404.601c9d2b.png";